import { formatListGroupData, getFormatListGroupData } from '../helpers/GaHelpers';
import { trackImpression, formatPrice } from './helpers';

// eslint-disable-next-line import/prefer-default-export
export const handleProductImpression = (productElement, tracker) => {
    const productId = productElement.getAttribute('data-product-id');
    const productName = productElement.getAttribute('data-product-name');
    const productVariantId = productElement.getAttribute('data-variant-id');
    const productPrice = productElement.getAttribute('data-actual-price');
    const brand = productElement.getAttribute('data-brand');
    const navigationId = productElement.getAttribute('data-navigation-id');
    const tagIds = productElement.getAttribute('data-tag-ids');
    const pathId = productElement.getAttribute('data-path-id');
    const positionFromData = productElement.getAttribute('data-order');
    const containerElement = productElement.parentElement;
    const { dataset: containerDataset } = containerElement;

    const { cmsVersion = 2 } = containerDataset;
    const isCmsV3 = Number(cmsVersion) === 3;

    const index = [...containerElement.children].indexOf(productElement);

    const isFromCMS = containerElement.classList.contains('impressions-observer--cms');
    const group = isFromCMS
        ? productElement.getAttribute('data-listing-name')
        : containerElement.getAttribute('data-products-group');
    const isListingLayout = ['listing', 'brandwall'].indexOf(group) !== -1;

    const {
        currentPage = 1,
        productsPerPage = 120,
        totalProducts = 5,
        productsPerRow: productsPerRowFromDataset = 10
    } = isListingLayout ? App.Config.Listing.paging : containerDataset;
    const { tiAddPath } = containerDataset;

    const productsPerRow = isCmsV3
        ? productsPerRowFromDataset
        : Math.floor(containerElement.offsetWidth / productElement.offsetWidth);

    const row = Math.floor(index / productsPerRow) + 1;
    const column = (index % productsPerRow) + 1;

    const position = isCmsV3
        ? positionFromData
        : ((currentPage * productsPerPage) - productsPerPage) + (((row * productsPerRow) - productsPerRow) + column);

    const listGroupDataExtraIds = [
        pathId && `path${pathId}`,
        navigationId && `nav${navigationId}`,
        tagIds && `tags${tagIds}`
    ];

    const data = getFormatListGroupData(
        {
            listGroupDataExtraIds,
            column,
            currentPage,
            group,
            isFromCMS,
            position,
            productsPerRow,
            productsPerPage,
            row,
            totalProducts,
            tiAddPath
        }
    );

    const trackingData = [
        'addEnhancedEcommerceImpressionContext',
        productId,
        productName || '-',
        formatListGroupData(data, '|'),
        brand,
        '-', // ?? category
        productVariantId,
        position || '-',
        formatPrice(productPrice)
    ];

    trackImpression(trackingData, tracker);
};
